import { ShareWalk } from './../components/ShareWalk';
import { sendMessageWalk } from './chat_actions';
import { WalkI } from './../interfaces/Walk';
import Api from "../services/Api"
import { getMyWalks } from '../redux/actions/walkActions'
import { isPlatform } from '@ionic/react';
import { SocialSharing } from '@ionic-native/social-sharing';
import { goToPage, goToPageWithState } from './app_actions';

const api = Api.getInstance()

export const removeWalk = async (walkId: number): Promise<any> => {
  return new Promise(resolve =>{
    api.get('/walk/remove/' + walkId).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          // console.log(data)
          let regexNumber = /\d+/g;
          const removed = {
            id: parseInt(data.message.match(regexNumber)[0]),
            showRemove: false
          }
          resolve(removed)
        } else {
          alert('Submit failed: ' + data.message)
        }
      })
    })
  })
}

export const copyWalk = (history: any, walkState: any) => {
  history.push({
    pathname: '/walk/copy',
    state: walkState
  })
}

export const editWalk = (history: any, walkId: number) => {
  history.push('/walk/edit/' + walkId)
}

export const createWalk = async (data: any): Promise<any> => {
  return new Promise(resolve => {
    api.post('/walk/save/' + 0, data).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
            resolve({
            id: data.id,
            walk: data.walk
          })
          getMyWalks()
        } else {
          alert('Submit failed: ' + data.message)
        }
      })
    })
  })
} 

export const bookWalk = async (walkId: number): Promise<any> => {
  return new Promise(resolve => {
    api.get('walk/book/' + walkId).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  })
}

export const cancelWalk = async (walk: WalkI): Promise<any> => {
  return new Promise(resolve => {
    const data = {
      cancel_text: 'Ställt in'
    }
    api.post('walk/cancel/' + walk.id, data).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          resolve(true)
          if(walk.bookedPerson) {
            const json = `{ "walkId": ${walk.id}, "walkWhen": "${walk.start}", "walkTitle": "${walk.name}" }`
            sendMessageWalk(3, walk.bookedPerson.id, api.tr('you_have_cancelled_walk'), json)
          }
        }
      })
    })
  })
}

export const createWalkOnDay = (history: any, walkState: any) => {
  history.push({
    pathname: '/walk/create',
    state: walkState
  })
}

export const shareWalk = (walkId: number) => {
  const shareUrl = 'https://app.walkingtalking.com/walk/sharewalk/' + walkId

  if (isPlatform('capacitor')) {
    const message = api.profile.firstName + api.tr('has_shared_walk_message')
    SocialSharing.share(message, 'Walking Talking', '', shareUrl)
  } else { 
    goToPage('/walk/walk/' + walkId)
  } 
}                              